import React from "react";
import "../styles/kampovi.css";
import Header from "./header.js";
import Footer from "./footer.js";
import { useSEO } from "./seo.js";

const Kampovi = () => {
  useSEO({
    naslov: "Odbojkaški kampovi za djecu - OK Virtus",
    opis: "Volley&Fun odbojkaški kampovi za djecu i mlade u organizaciji Odbojkaškog kluba Virtus, koje vode odbojkaški reprezentativci i igrači Superlige.",
    putanja: "/kampovi",
  });

  return (
    <div>
        <Header/>
        <div className="sadrzaj-kampovi">
          <h1>Kampovi</h1>
          <p>
            Organiziramo odbojkaške kampove za djecu i mlade koje vode vrhunski treneri,
            odbojkaški reprezentativci i igrači Superlige. Više informacija uskoro!
          </p>
        </div>
        <Footer/>
    </div>
  );
};

export default Kampovi;
